import router from '../router';

/**
 * API Interceptor plugin
 * Intercepts all fetch requests to detect 403 errors with "Access denied" message
 */
const apiInterceptor = {
  /**
   * Install method for Vue plugin system
   * @param {Object} app - Vue application instance
   */
  install(app) {
    // Store original fetch function
    const originalFetch = window.fetch;
    
    // Função para bloquear o IP e redirecionar para a página de bloqueio
    const blockIpAndRedirect = () => {
      console.warn('IP BLOQUEADO: Access denied detectado');
      
      // Limpar TODAS as credenciais de autenticação
      localStorage.removeItem('userToken');
      localStorage.removeItem('userLoggedIn');
      localStorage.removeItem('username');
      localStorage.removeItem('botPermissions');
      
      // Limpar cookies
      document.cookie.split(';').forEach(cookie => {
        const [name] = cookie.trim().split('=');
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      
      // Definir flag de IP bloqueado
      localStorage.setItem('ipBlocked', 'true');
      
      // Forçar redirecionamento para a página de bloqueio
      window.location.href = '/blocked';
    };
    
    // Replace fetch with our own implementation
    window.fetch = async function(...args) {
      // Se o IP já estiver bloqueado, bloqueie TODAS as solicitações à API
      if (localStorage.getItem('ipBlocked') === 'true') {
        console.warn('Tentativa de requisição com IP bloqueado');
        blockIpAndRedirect();
        // Simular erro de rede para falhar a requisição
        throw new Error('Network error: IP blocked');
      }
      
      // Call original fetch
      try {
        const response = await originalFetch.apply(this, args);
        
        // Check for IP blocking (403 status code)
        if (response.status === 403) {
          // Clone response to read body without consuming the original
          const clonedResponse = response.clone();
          try {
            // Tentar ler o corpo da resposta como JSON
            const text = await clonedResponse.text();
            let data;
            
            try {
              data = JSON.parse(text);
            } catch (e) {
              // Se não for JSON válido, não é nossa resposta específica
              return response;
            }
            
            // Verificar se corresponde EXATAMENTE ao formato {"detail": "Access denied."}
            if (data && data.detail === 'Access denied.') {
              // Ativar bloqueio de IP
              blockIpAndRedirect();
            }
          } catch (e) {
            console.error('Erro ao processar resposta:', e);
          }
        }
        
        return response;
      } catch (error) {
        // Pass through the error
        throw error;
      }
    };

    // Expose helper function to check if IP is blocked
    app.config.globalProperties.$isIpBlocked = () => {
      return localStorage.getItem('ipBlocked') === 'true';
    };

    // Expose helper function to handle IP blocking detection
    app.config.globalProperties.$checkIpBlocking = (response) => {
      if (response && response.status === 403) {
        // Clear all authentication data
        localStorage.removeItem('userToken');
        localStorage.removeItem('userLoggedIn');
        localStorage.removeItem('username');
        localStorage.removeItem('botPermissions');
        
        // Set IP blocked flag
        localStorage.setItem('ipBlocked', 'true');
        
        // Redirect to blocked page
        router.push('/blocked');
        return true;
      }
      return false;
    };
  }
};

export default apiInterceptor;
